import { useEffect } from 'react'
import { FaPaintRoller, FaHammer, FaDotCircle } from 'react-icons/fa'
import { GiBrickWall, GiFloorPolisher, GiWoodenPier } from 'react-icons/gi'
import { MdElectricalServices, MdPlumbing } from 'react-icons/md'
import { IoMdOutlet } from 'react-icons/io'
import { HiMiniWrenchScrewdriver, HiLightBulb } from 'react-icons/hi2'
import { PiFanFill } from 'react-icons/pi'
import { RiFridgeFill } from 'react-icons/ri'
import { sendPageView } from '../gtmUtils'

function Handyman() {
	useEffect(() => {
		sendPageView()
	}, [])

	return (
		<>
			<div className='container'>
				<div className='handyman'>
					<h1 className='large'>Handyman Services</h1>
					<h2 className='large'>Services Summary</h2>

					<p>
						I offer a variety of services both inside and outside of your property. Some of these
						services include:
					</p>
					<h3 className='handyman-section-title'>Inside</h3>
					<ul className='handyman-inside-list'>
						<li className='handyman-inside-item'>
							<FaPaintRoller className='handyman-icon' />
							Painting
						</li>
						<li className='handyman-inside-item'>
							<GiBrickWall className='handyman-icon' />
							Drywall repair
						</li>
						<li className='handyman-inside-item'>
							<HiMiniWrenchScrewdriver className='handyman-icon' />
							Ikea and Wayfair furniture assembly
						</li>
						<li className='handyman-inside-item'>
							<RiFridgeFill className='handyman-icon' />
							Appliance installation
						</li>
						<li className='handyman-inside-item'>
							<MdPlumbing className='handyman-icon' />
							Minor plumbing tasks
						</li>
						<li className='handyman-inside-item'>
							<HiMiniWrenchScrewdriver className='handyman-icon' />
							General Repairs
						</li>
					</ul>

					<h3 className='handyman-section-title'>Outside</h3>
					<ul className='handyman-outside-list'>
						<li className='handyman-outside-item'>
							<FaPaintRoller className='handyman-icon' />
							Painting
						</li>
						<li className='handyman-outside-item'>
							<GiWoodenPier className='handyman-icon' />
							Decking
						</li>
						<ul className='handyman-outside-list-item'>
							<li className='handyman-outside-second-list-item'>
								<FaDotCircle className='handyman-icon' />
								Staining/Sealing
							</li>
							<li className='handyman-outside-second-list-item'>
								<FaDotCircle className='handyman-icon' />
								Rebuild and Resurfacing
							</li>
							<li className='handyman-outside-second-list-item'>
								<FaDotCircle className='handyman-icon' />
								Railing Installtion
							</li>
						</ul>
						<li className='handyman-outside-item'>
							<HiMiniWrenchScrewdriver className='handyman-icon' />
							General Repairs
						</li>
					</ul>
				</div>
			</div>
		</>
	)
}

export default Handyman
